import {connect} from 'react-redux';
import {Component} from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Modal from '-/components/general/Modal';
import SessionService from '-/services/SessionService';
import NavigationService from '-/services/NavigationService';
import {isDocumentsMode, isStipsMode} from '-/util/util';
import StipsService from '-/services/StipsService';
import validationStyles from '-/styles/sections/validation';

const styles = theme => ({
    ...validationStyles(theme)
});

class VerifyAccountCCR extends Component {
    static propTypes = {
        onNextClick: PropTypes.func
    };

    static defaultProps = {
        onNextClick: () => {}
    };

    render() {
        const {onNextClick, username, ccrAuthenticated, classes = {}} = this.props;
        return (
            <Modal className="verify-account" buttonText="Continue" showButton={ccrAuthenticated} onClick={() => onNextClick()}>
                <section className={classes.description}>
                    <div className={classes.icon}>
                        <i className="fa fa-id-card" alt="ID Card" />
                    </div>
                    <div className={classes.text}>
                        {ccrAuthenticated ? (
                            <h3>Welcome, {username} <br />You are logged in as a CCR</h3>
                        ) : (
                            <h3>Please log in as a CCR in the admin</h3>
                        )}
                    </div>
                </section>
            </Modal>
        );
    }
}

const mapStateToProps = () => {
    return {
        ccrAuthenticated: SessionService.authenticated() && SessionService.isCCRMode(),
        username: SessionService.getUsername()
    };
};

const mapDispatchToProps = () => {
    return {
        onNextClick: () => {
            if (isStipsMode()) {
                StipsService.enter();
            } else if (isDocumentsMode()) {
                NavigationService.next('documents');
            } else {
                NavigationService.next('validationInfo');
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(VerifyAccountCCR));
